import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.HeroEcoRenovationSlice} HeroEcoRenovationSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroEcoRenovationSlice>} HeroEcoRenovationProps
 * @param {HeroEcoRenovationProps}
 */
const HeroEcoRenovation = ({ slice, context, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-pink pt-[87px] pb-16 md:pt-[100px] md:pb-28 ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="flex flex-col max-w-[1400px] m-auto px-4 md:px-7 lg:px-10 ">

        <div className="mb-5">
          <Breadcrumbs context={context} index={index} />
        </div>

        <div className="flex">
          <img src="images/eco-1.svg"  loading={index === 0 ? '' : 'lazy'}
            className="aspect-square w-1/4 max-w-[114px] object-contain img-eco-1"
            alt="Pictogramme représentant un soleil" />
          <img src="images/eco-2.svg"  loading={index === 0 ? '' : 'lazy'}
            className="aspect-square w-1/4 max-w-[114px] object-contain img-eco-2 -ml-[2px]"
            alt="Pictogramme représentant un soleil" />
          <img src="images/eco-3.svg"  loading={index === 0 ? '' : 'lazy'}
            className="aspect-square w-1/4 max-w-[114px]  object-contain img-eco-3 -ml-[2px]"
            alt="Pictogramme représentant un soleil" />
          <img src="images/eco-4.svg"  loading={index === 0 ? '' : 'lazy'}
            className="aspect-square w-1/4 max-w-[114px] object-contain img-eco-4 -ml-[2px]"
            alt="Pictogramme représentant un soleil" />
        </div>

        <div className="flex flex-col lg:flex-row pt-30px md:border-t-2 border-dark-grey  md:-mt-[2.5px]">
          <div className="basis-1/2 flex flex-col md:pr-24 border-b-2 md:border-b-0 border-dark-grey">
            <div className="h1-like mb-4 md:mb-5">
              <PrismicRichText field={slice.primary.title} components={{
                heading1: ({ children }) => <h1>{children}</h1>,
                heading2: ({ children }) => <h2>{children}</h2>,
              }} />
            </div>
            <div className="pb-30px md:pb-0 max:w-[370px]">
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
          <div className="basis-1/2 flex flex-col lg:flex-row pt-30px md:pt-0">
            <div className="basis-1/2 md:pr-30px mb-30px lg:mb-0">

              <PrismicRichText field={slice.primary.description_1} />
            </div>
            <div className="basis-1/2 mdd:pl-30px">
              <PrismicRichText field={slice.primary.description_2} />
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default HeroEcoRenovation;
